export default "__VITE_ASSET__f4f5dcfe__"